// extracted by mini-css-extract-plugin
module.exports = {"fullscreen-button":"fullscreen-button_fullscreen-button__byKex","editor":"fullscreen-button_editor__mbS5n","readonly":"fullscreen-button_readonly__rk3_d"};